import React, { useState, useEffect } from "react";
import { producaov2 as api } from "../../../../services/apis";
import { Icon, Loader, Button } from "semantic-ui-react";
import {
  Container,
  Content,
  Title,
  ContainerInputSearch,
  Input,
  CreateButton,
  SemanticTable,
} from "./styled";
import swal from "sweetalert";
import { withRouter } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../../services/auth";

const CardCombos = (props) => {
  const [search, setSearch] = useState("");
  const [combos, setCombos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadAuth();
    loadCombos();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const loadCombos = async () => {
    api
      .get("/card-combos/")
      .then(async (res) => {
        let logs = { local: "CardCombos", texto: `listou os combos` };
        await api.post("system_logs", { acao: JSON.stringify(logs) });
        setCombos([...combos, ...res.data]);
        setLoading(false);
      })
      .catch((err) => {
        swal("Não foi possível carregar os combos", err, "").then((res) =>
          props.history.push("/admin/")
        );
      });
  }

  return (
    <>
      <Container>
        <AdminMenu />

        {loading ? (
          <Loader active inline="centered" size="massive" />
        ) : (
          <Content>
            <Title>Combos</Title>

            <ContainerInputSearch className="ui fluid left icon input">
              <Input
                type="search"
                placeholder="Procurar COMBOS..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <Icon name="search icon" />

              <CreateButton to="/admin/combos/criar">Criar</CreateButton>
            </ContainerInputSearch>

            <SemanticTable size="big" celled>
              <SemanticTable.Header>
                <SemanticTable.Row>
                  <SemanticTable.HeaderCell>Id</SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>nome</SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>id combo</SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>valor total</SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>valor combo</SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>página do pacote</SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>imagem</SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>Ações </SemanticTable.HeaderCell>
                </SemanticTable.Row>
              </SemanticTable.Header>
              <SemanticTable.Body>
                {combos
                  .filter((comb) =>
                    comb.nome.toLowerCase().includes(search.toLowerCase())
                  )
                  .map((combo, index) => (
                    <SemanticTable.Row>
                      <SemanticTable.Cell>{combo.id}</SemanticTable.Cell>
                      <SemanticTable.Cell>{combo.nome}</SemanticTable.Cell>
                      <SemanticTable.Cell>{combo.idCombo}</SemanticTable.Cell>
                      <SemanticTable.Cell>{combo.valueTotal}</SemanticTable.Cell>
                      <SemanticTable.Cell>{combo.valueCombo}</SemanticTable.Cell>
                      <SemanticTable.Cell>{combo.pageLink}</SemanticTable.Cell>
                      <SemanticTable.Cell>{combo.image}</SemanticTable.Cell>
                      <SemanticTable.Cell>
                        <div className="actions">
                          <Button
                            icon="edit icon"
                            color={"blue"}
                            onClick={() =>
                              window.open(
                                `/admin/combos/detalhes/${combo.id}`
                              )
                            }
                          />
                          <Button
                            icon="delete icon"
                            color={"red"}
                            onClick={async () =>
                              await api.delete(`/card-combo/${combo.id}`)
                            }
                          />
                        </div>
                      </SemanticTable.Cell>
                    </SemanticTable.Row>
                  ))}
              </SemanticTable.Body>
            </SemanticTable>
          </Content>
        )}
      </Container>
    </>
  );
};

export default withRouter(CardCombos);
